import { ENV } from "shared-tsi";
import { environmentBase } from "./environment.base";

export const environment = {
    ...environmentBase,
    production: false,
    name: ENV.DEV,
    apiService_Auth: '/backend-login',
    apiService_Erp: '/backend-api',
    apiService_Adjuntos: '/backend-adjuntos',
    apiService_Report: '/backend-report',
    apiService_SqlReport: '/backend-sql-report',
    aiSqlReportBaseUrl: '/ai-sql-report',
    recaptcha: {
        siteKey: '6Ld4ZT0sAAAAAG9XH7-7d4s_0EAIToZXpeeCJGO5',
    },
    cacheable: false
}